import React from 'react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../../store/reportStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { Circles } from '../../common/loadingComponent';
import NoDataComponent from '../../common/noDataComponent';
import EsgSubfactorStatistics from './esgSubfactorStatistics';

const ESG_SUBFACTORS_SECTION_TYPE = {
    subfactorsE: "ESGSubfactorsE",
    subfactorsS: "ESGSubfactorsS",
    subfactorsG: "ESGSubfactorsG"
}

class ESGSubfactorsSection extends React.Component {

    get section() {
        return this.props.sections.find(o => o.id === this.props.sectionId).subsections.find(q => q.id === this.props.subsectionId);
    }

    componentDidMount = () => {
        this.props.loadIfExpanded(this.props.sectionId);
    }

    render() {
        const { data, loadingMoreData } = this.section;

        if (loadingMoreData)
            return <Circles />

        if (isNullOrUndefined(data) || isNullOrUndefined(data.subfactors) || data.subfactors.length === 0)
            return <NoDataComponent />

        switch (this.props.subsectionId) {
            case ESG_SUBFACTORS_SECTION_TYPE.subfactorsE:
            case ESG_SUBFACTORS_SECTION_TYPE.subfactorsS:
            case ESG_SUBFACTORS_SECTION_TYPE.subfactorsG:
                return this.renderContent(data);
            default:
                return <NoDataComponent />;
        }
    }

    renderContent = (data) => (
        <div className="columns is-tablet is-multiline is-centered esg-subfactor-section">
            {data.subfactors.map((s, idx) =>
                <div className="column is-4-widescreen is-12-mobile is-4" key={idx}>
                    <EsgSubfactorStatistics
                        subfactor={s.type}
                        score={s.value}
                        data={s}
                        sectorIdentificator={data.sectorIdentificator}
                        primaryAttrCountry={this.getPrimaryAttrCountry()}
                    />
                </div>
            )}
        </div>
    )

    getPrimaryAttrCountry = () => {
        const { id } = this.props;
        const { entityInfos } = this.props.entity;

        if (entityInfos && entityInfos[id] && entityInfos[id].result && entityInfos[id].result.reports) {
            switch (entityInfos[id].result.reports.primaryAttr) {
                case 1:
                    return 'CZ';
                case 2:
                    return 'SK';
                default:
                    return undefined;
            }
        } else {
            return undefined;
        }
    }
}

export default withLocalize(withRouter(connect(
    state => ({ ...state.report, entity: state.entityIdentRow }),
    dispatch => bindActionCreators(reportActions, dispatch)
)(ESGSubfactorsSection)));